import { Outlet } from "react-router-dom";
import { useState } from "react";
import { Sidebar } from "#/components/app-shell/Sidebar";
import { Topbar } from "#/components/app-shell/Topbar";
import { InactivityLogout } from "./InactivityLogout";

export function AppShell() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <div className="flex min-h-screen">
        <Sidebar
          mobileOpen={mobileNavOpen}
          onCloseMobile={() => setMobileNavOpen(false)}
        />

        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar onOpenMobileNav={() => setMobileNavOpen(true)} />
          <InactivityLogout />

          <main className="flex-1 overflow-x-hidden px-4 py-4 sm:px-6 lg:px-8 lg:py-6">
            <div className="mx-auto w-full max-w-7xl">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}